import { BreakCandleTypeLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakCandleTypeLine';
import { BreakCandleTypeTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/BreakCandleTypeTacticPanel';
import BreakCandleTypeWrapper from '../../../../components/displays/tradeplans/softOrderModules/setupModules/BreakCandleTypeModule/wrapper/BreakCandleTypeWrapper';
import CandleBreakTypeDocs from '../../../../components/forms/tradeplans/documentation/CandleBreakTypeDocs';
import { BreakCandleTypeData } from './breakCandleTypeData';
import { validateBreakCandleType } from './validateBreakCandleType';

export const BreakCandleType = {
  //data class
  dataStore: BreakCandleTypeData,

  //string constants
  name: 'BREAK_CANDLE_TYPE',
  tacticLabel: 'Break Candle Type',
  addTacticLabel: 'Add Break Candle Type',
  category: 'Setup',

  // components
  tradePlanFormModule: null,
  tacticPanel: BreakCandleTypeTacticPanel,
  addTacticPanel: null,
  wrapper: BreakCandleTypeWrapper,
  chartSoftOrderComponent: BreakCandleTypeLine,
  documentation: CandleBreakTypeDocs,
  alertDetailsComponent: null, //todo

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateBreakCandleType,
};
